import { StatusBadge } from '@immo/ui-kit';
import type { FleetHostThrottle } from '@immo/api-contract';
import { useTranslations } from '@/i18n/use-translations';
import { throttleReason } from './health-figures';

export function FleetThrottleBadge({ throttle }: { readonly throttle: FleetHostThrottle }) {
  const t = useTranslations('pages.admin.fleet.health');
  const reason = throttleReason(throttle);

  return <StatusBadge tone="warning" dot label={t('throttled', { reason: t(reason.key, reason.values) })} />;
}
